export default __webpack_public_path__ + "static/media/medrink169.d5150d76.jpg";